/**
 * TestNimbusMath - Página de prueba para NimbusMath
 * Usar para verificar que la integración funciona antes de implementar en producción
 * 
 * Para probar: importar este componente en una ruta temporal
 */

import React, { useState } from 'react';
import RichContentInputWithMath from './RichContentInputWithMath';

const TestNimbusMath = () => {
    const [content, setContent] = useState('');
    const [mathmlOutput, setMathmlOutput] = useState('');

    const handleChange = (e) => {
        setContent(e.target.value);
        
        // Extraer MathML del contenido para mostrar en debug
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = e.target.value;
        const formulas = tempDiv.querySelectorAll('.Wirisformula, .math-tex');
        if (formulas.length > 0) {
            const mathmlList = Array.from(formulas).map(f => {
                const encoded = f.getAttribute('data-mathml');
                try {
                    return decodeURIComponent(encoded);
                } catch {
                    return encoded;
                }
            });
            setMathmlOutput(mathmlList.join('\n\n'));
        }
    };

    return (
        <div className="p-8 max-w-4xl mx-auto">
            <h1 className="text-2xl font-bold text-[#1a3d82] mb-2">
                🧪 Test NimbusMath
            </h1>
            <p className="text-gray-600 mb-6">
                Prueba de integración de NimbusMath con CKEditor 5
            </p>

            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                <RichContentInputWithMath
                    label="Editor con NimbusMath"
                    name="testEditor"
                    value={content}
                    onChange={handleChange}
                    placeholder="Escribe aquí y usa el botón √ Fórmula para insertar ecuaciones..."
                />
            </div>

            <div className="bg-gray-100 rounded-lg p-6">
                <h2 className="text-lg font-semibold mb-3">Debug - Contenido HTML:</h2>
                <pre className="bg-white p-4 rounded border text-xs overflow-auto max-h-48">
                    {content || '(vacío)'}
                </pre>

                {mathmlOutput && (
                    <>
                        <h2 className="text-lg font-semibold mt-4 mb-3">MathML extraído:</h2>
                        <pre className="bg-white p-4 rounded border text-xs overflow-auto max-h-48 text-green-700">
                            {mathmlOutput}
                        </pre>
                    </>
                )}
            </div>

            <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <h3 className="font-semibold text-blue-800 mb-2">📝 Instrucciones:</h3>
                <ol className="list-decimal list-inside text-sm text-blue-700 space-y-1">
                    <li>Haz clic en el botón "√ Fórmula" arriba del editor</li>
                    <li>Se abrirá el panel MathPanel (Nimbus Math)</li>
                    <li>Escribe o selecciona símbolos matemáticos</li>
                    <li>Haz clic en "Insertar" para agregar la fórmula al editor</li>
                    <li>El MathML se mostrará en la sección de debug</li>
                </ol>
            </div>
        </div>
    );
};

export default TestNimbusMath;
